import { Type } from '@angular/core';
import {
  CommissioningAddRoomModalComponent,
  CommissioningAddVentilationModalComponent,
  CommissioningAssignChannelModalComponent,
  CommissioningAssignHeatingCircuitModalComponent,
  CommissioningAssignmentLoaderModalComponent,
  CommissioningCodeModalComponent,
  CommissioningDeviceTypeModalComponent,
  CommissioningFinalResultModalComponent,
  CommissioningPairingModalComponent,
  CommissioningPairingResultModalComponent,
  CommissioningReminderModalComponent,
} from './';

export type CommisioningComponent =
  | CommissioningDeviceTypeModalComponent
  | CommissioningCodeModalComponent
  | CommissioningReminderModalComponent
  | CommissioningPairingModalComponent
  | CommissioningPairingResultModalComponent
  | CommissioningAssignHeatingCircuitModalComponent
  | CommissioningAddVentilationModalComponent
  | CommissioningAddRoomModalComponent
  | CommissioningAssignChannelModalComponent
  | CommissioningAssignmentLoaderModalComponent
  | CommissioningFinalResultModalComponent;

export interface CommissioningStrategy {
  steps: Type<CommisioningComponent>[];
}

// Strategies are factories so component classes are only dereferenced at call time; referencing
// them at module load breaks the init order (cycle: commissioning.model -> commissioning.strategy
// -> component -> commissioning.service -> commissioning.model).
export type CommissioningStrategyFactory = () => CommissioningStrategy;

export const initialStrategy: CommissioningStrategyFactory = () => ({
  steps: [CommissioningDeviceTypeModalComponent],
});

export const eTRVStrategy: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignHeatingCircuitModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningAddRoomModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});

export const eTRVStandaloneStrategy: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningAddRoomModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});

export const csStrategy: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAddRoomModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});

export const csRepeaterStrategy: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});

export const repeaterStrategy: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});

export const fhtStrategy: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignChannelModalComponent,
    CommissioningAssignHeatingCircuitModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});

export const fhtStandaloneStrategy: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignChannelModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});

export const airQualitySensorStrategy: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAddRoomModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});

export const vicareThermostatCsStrategyStrategy: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
  ],
});

export const vicareThermostatCsRepeaterStrategy: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
  ],
});

export const vicareThermostatRepeaterStrategy: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
  ],
});

export const vicareThermostatVitotrol_100E: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
  ],
});

export const vicareThermostatVitotrol_300E: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignHeatingCircuitModalComponent,
    CommissioningAddVentilationModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});

export const vicareThermostatVitotrol_300E_System: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignHeatingCircuitModalComponent,
    CommissioningAddVentilationModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});

export const eTRVStrategyOBNG: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningAddRoomModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});

export const fhtStrategyOBNG: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAssignChannelModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});

export const vicareThermostatVitotrol_300E_OBNG: CommissioningStrategyFactory = () => ({
  steps: [
    CommissioningDeviceTypeModalComponent,
    CommissioningCodeModalComponent,
    CommissioningReminderModalComponent,
    CommissioningPairingModalComponent,
    CommissioningPairingResultModalComponent,
    CommissioningAddVentilationModalComponent,
    CommissioningAssignmentLoaderModalComponent,
    CommissioningFinalResultModalComponent,
  ],
});
